import { t as gsapWithCSS } from "@theme/gsap";
import { t as ensureScrollTrigger } from "@theme/gsap-utils";
import { t as Observer } from "@theme/Observer";
//#region frontend/islands/story-steps.js
gsapWithCSS.registerPlugin(Observer);
var StorySteps = class extends window.HTMLElement {
	async connectedCallback() {
		const ScrollTrigger = await ensureScrollTrigger();
		this.steps = gsapWithCSS.utils.toArray(this.querySelectorAll(".story-step"));
		this.activationOffset = 30;
		this._triggers = [];
		const _toggleStep = (step, dir) => {
			gsapWithCSS.to(step, {
				autoAlpha: dir,
				ease: "power3.out"
			});
		};
		this.steps.forEach((step, i) => {
			const stepNumberActive = step.querySelector(".step-number-active");
			const isFirst = i === 0;
			const isLast = i === this.steps.length - 1;
			this._triggers.push(ScrollTrigger.create({
				trigger: step,
				start: `top bottom-=${this.activationOffset}%`,
				end: `bottom bottom-=${this.activationOffset}%`,
				onEnter: () => _toggleStep(stepNumberActive, 1),
				onEnterBack: () => _toggleStep(stepNumberActive, 1),
				onLeave: () => !isLast && _toggleStep(stepNumberActive, 0),
				onLeaveBack: () => !isFirst && _toggleStep(stepNumberActive, 0)
			}));
		});
		this._setupMobile();
	}
	_setupMobile() {
		this._mobileIndex = 0;
		this._track = this.querySelector(".story-steps-track");
		this._mobileStepNumbers = gsapWithCSS.utils.toArray(this.querySelectorAll(".story-step-mobile .step-number-active"));
		const prevBtn = this.querySelector("[data-mobile-prev]");
		const nextBtn = this.querySelector("[data-mobile-next]");
		if (!prevBtn || !nextBtn) return;
		this._onPrev = () => this._mobileGo(-1);
		this._onNext = () => this._mobileGo(1);
		prevBtn.addEventListener("click", this._onPrev);
		nextBtn.addEventListener("click", this._onNext);
		this._prevBtn = prevBtn;
		this._nextBtn = nextBtn;
		this._observer = Observer.create({
			target: this._track,
			type: "touch,pointer",
			tolerance: 10,
			lockAxis: true,
			onLeft: () => this._mobileGo(1),
			onRight: () => this._mobileGo(-1)
		});
	}
	disconnectedCallback() {
		this._triggers?.forEach((t) => t.kill());
		this._observer?.kill();
		this._prevBtn?.removeEventListener("click", this._onPrev);
		this._nextBtn?.removeEventListener("click", this._onNext);
	}
	_mobileGo(dir) {
		if (this._isTweening) return;
		const count = this._mobileStepNumbers.length;
		const next = gsapWithCSS.utils.clamp(0, count - 1, this._mobileIndex + dir);
		if (next === this._mobileIndex) return;
		const prev = this._mobileIndex;
		this._mobileIndex = next;
		this._isTweening = true;
		gsapWithCSS.to(this._mobileStepNumbers[prev], {
			autoAlpha: 0,
			ease: "power3.out"
		});
		gsapWithCSS.to(this._mobileStepNumbers[next], {
			autoAlpha: 1,
			ease: "power3.out"
		});
		const track = this._track;
		const slideWidth = track.querySelector(".story-step-mobile").offsetWidth;
		gsapWithCSS.to(track, {
			x: -(next * slideWidth),
			duration: .5,
			ease: "power2.inOut",
			onComplete: () => {
				this._isTweening = false;
			}
		});
	}
};
window.customElements.define("story-steps", StorySteps);
//#endregion
